import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './views/layout/base/base.component';
import { AuthGuard } from './core/guard/auth.guard';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';


const routes: Routes = [
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
       path: 'icons',
       loadChildren: () => import('./views/pages/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'setting',
        loadChildren: () => import('./views/pages/setting/setting.module').then(m => m.SettingModule)
      },
      {
        path: 'manage-information',
        loadChildren: () => import('./views/pages/manage-information/manage-information.module').then(m => m.ManageInformationModule)
      },
      {
        path: 'data-verification',
        loadChildren: () => import('./views/pages/data-verification/data-verification.module').then(m => m.DataVerificationModule)
      },
      {
        path: 'equipment',
        loadChildren: () => import('./views/pages/manage-equipment/manage-equipment.module').then(m => m.ManageEquipmentModule)
      },
      {
        path: 'request-equipment',
        loadChildren: () => import('./views/pages/request-equipment/request-equipment.module').then(m => m.RequestEquipmentModule)
      },
      {
        path: 'master-equipment',
        loadChildren: () => import('./views/pages/master-equipment/master-equipment.module').then(m => m.MasterEquipmentModule)
      },
      {
        //canActivate: [AuthGuard],
        path: "user-management",
        loadChildren: () =>
          import("./views/pages/user-management/user-management.module").then((m) => m.UserManagementModule),
      },
      {
        path: 'setting-equipment',
        loadChildren: () => import('./views/pages/setting-equipment/setting-equipment.module').then(m => m.SettingEquipmentModule)
      },
      {
        path: 'mst-equipment-quota',
        loadChildren: () => import('./views/pages/mst-equipment-quota/mst-equipment-quota.module').then(m => m.MstEquipmentQuotaModule)
      },
      {
        path: 'help',
        loadChildren: () => import('./views/pages/help/help.module').then(m => m.HelpModule)
      },
      {
        path: 'auth',
        loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule)
      },
      { path: '', redirectTo: 'dashboard/index', pathMatch: 'full' }, 
    ]
  },
  { 
    path: 'error',
    component: ErrorPageComponent,
    data: {
      'type': 404,
      'title': 'Page Not Found',
      'desc': 'Oopps!! The page you were looking for doesn\'t exist.'
    }
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
